import { NgModule } from '@angular/core';
import { I18nService } from './i18n.service';
import { Translations } from 'src/i18n';
import { CommonModule } from '@angular/common';
import { I18nModule } from './i18n.module';
import { CIMODE } from './models-internal';

export function i18nTestingFactory() {
  const service = new I18nService();

  service.initialise({
    initialLang: CIMODE,
    debug: false,
    resources: {
      en: { translation: Translations.en },
      pl: { translation: Translations.pl },
    },
  });

  return service;
}

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
  ],
  providers: [
    { provide: I18nService, useFactory: i18nTestingFactory },
  ]
})
export class I18nTestingModule { }
